import React from "react";

/**
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 30px 44px;
gap: 10px;
height: 147px;
background: linear-gradient(180deg, #00095B 0%, #066FEF 100%);
flex: none;
order: 0;
align-self: stretch;
flex-grow: 0;
*/

const Header = () => {
  return (
    <div className="flex flex-col items-center justify-center p-[30px] gap-[10px] h-[147px] bg-gradient-to-b from-[#00095B] to-[#066FEF]">
      <img src="/img/logo.svg" alt="logo" />
    </div>
  );
};

export default Header;
